export default __webpack_public_path__ + "static/media/profile_blue.20f23f51.gif";